import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Products from "../views/Products.vue";
import Services from "../views/Services.vue";
import News from "../views/News.vue";
import FAQ from "../views/FAQ.vue";
import Contact from "../views/Contact.vue";
import Login from "../components/Login.vue";
import AdminLayout from "../views/admin/AdminLayout.vue";
import AdminProducts from "../views/admin/AdminProducts.vue";
import AdminServices from "../views/admin/AdminServices.vue";
import AdminContacts from "../views/admin/AdminContacts.vue";
import AdminNews from "../views/admin/AdminNews.vue";

const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/about", name: "About", component: About },
  { path: "/products", name: "Products", component: Products },
  { path: "/services", name: "Services", component: Services },
  { path: "/news", name: "News", component: News },
  { path: "/faq", name: "FAQ", component: FAQ },
  { path: "/contact", name: "Contact", component: Contact },
  { path: "/login", name: "Login", component: Login },
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      { path: "", redirect: "/admin/products" },
      { path: "products", name: "AdminProducts", component: AdminProducts },
      { path: "services", name: "AdminServices", component: AdminServices },
      { path: "contacts", name: "AdminContacts", component: AdminContacts },
      { path: "news", name: "AdminNews", component: AdminNews },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 瀏覽器「上一頁/下一頁」時恢復原本位置，其餘一律捲回最上方
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// 路由守衛 - 未登入不能進入 /admin
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      next("/login");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
